import { z } from 'zod';

export const errorCodes = [
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'VERSION_CONFLICT',
  'RATE_LIMITED',
  'DUPLICATE_SUBMISSION',
  'ORIGIN_NOT_ALLOWED',
  'OWNER_SAFETY',
  'PRECONDITION_FAILED',
  'INTERNAL',
] as const;
export type ErrorCode = (typeof errorCodes)[number];

export const fieldErrorSchema = z.object({ field: z.string(), message: z.string() });

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(errorCodes),
    message: z.string(),
    fieldErrors: z.array(fieldErrorSchema).default([]),
    retryable: z.boolean(),
    requestId: z.string(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>['error'];
export type FieldError = z.infer<typeof fieldErrorSchema>;

export const retryableCodes: ReadonlySet<ErrorCode> = new Set(['RATE_LIMITED', 'INTERNAL']);
